import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Select from 'react-select'
import Text from '#components/a/Text'
import Loading from '#components/a/Loading'

export function RessourcenAbteilungSelect({abteilungenLoading, abteilungen, selectedAbteilungId, selectAbteilung}) {
  if (!abteilungenLoading && (abteilungen?.length === 0 || !selectedAbteilungId)) {
    return null
  }

  const mappedAbteilungen = abteilungen?.map(abt => ({
    value: abt.id,
    label: abt.name,
    backgroundColor: abt.backgroundColor,
    textColor: abt.textColor,
  }))

  const selectedMappedAbteilung = mappedAbteilungen?.find(o => o.value === selectedAbteilungId)

  const style = {
    control: (styles, state) => ({
      ...styles,
      backgroundColor: selectedMappedAbteilung.backgroundColor,
      border: 0,
      boxShadow: 0,
      '&:hover': {
        border: 0,
      },
    }),
    singleValue: styles => ({
      ...styles,
      color: selectedMappedAbteilung.textColor,
    }),
    dropdownIndicator: styles => ({
      ...styles,
      color: selectedMappedAbteilung.textColor,
    }),
  }

  return (
    <div className="abteilungSelect" data-testid="ressourcen-abteilung-select">
      <Text text={i18n.t('abteilung_erstellen_abteilung_label')} />
      {abteilungenLoading ? (
        <Loading />
      ) : (
        <Select
          styles={style}
          className="dropdownSelect"
          classNamePrefix="dropdownSelect"
          value={selectedMappedAbteilung}
          onChange={opt => {
            selectAbteilung(opt.value)
          }}
          options={mappedAbteilungen}
        />
      )}
    </div>
  )
}

RessourcenAbteilungSelect.propTypes = {
  abteilungen: PropTypes.array,
  abteilungenLoading: PropTypes.bool,
  selectedAbteilungId: PropTypes.number,
  selectAbteilung: PropTypes.func,
}
